import React from "react";

interface TickIconProps {
  size?: number | string;
  className?: string;
  onClick?: () => void;
  color?:string;}

const TickIcon: React.FC<TickIconProps> = ({
  size = 22,
  className,
  onClick,
  color="currentColor"
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <path
      d="M2 11.83L8.83 18.66L22.5141 5"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default TickIcon;
